import * as React from "react";
import MuiThemeProviderDynamic from "./mui-theme-dynamic";
import { Routes, Route, Navigate, HashRouter } from "react-router-dom";

import { AboutPage } from "app/ui/pages/about.page";
import { BrowsePage } from "app/ui/pages/browse.page";
import { SearchPage } from "app/ui/pages/search.page";
import { Footer } from "app/ui/elements/footer";
import ThemeProvider from "app/theme-context";
import { LoginPage } from "app/ui/pages/login.page";
import { AuthContext, AuthProvider } from "app/services/auth/ContextProvider";
import { IdproviderCallback } from "app/services/auth/IdproviderCallback";
import { resolveInject } from "app/di";
import { IAppConfigProvider } from "app/services/config/app-config-loader.service";

export const Main = () => {
    return (
        <ThemeProvider>
            <MuiThemeProviderDynamic>
                <HashRouter>
                    <AuthProvider>
                        <Routes>
                            <Route path="/login" element={<LoginRoute />} />
                            <Route path="/logout" element={<LogoutRoute />} />
                            <Route path="/auth/callback" element={<IdproviderCallback />} />
                            <Route
                                path="/about"
                                element={<RestrictedRoute component={AboutPage} />}
                            />
                            <Route
                                path="/view"
                                element={<RestrictedRoute component={BrowsePage} />}
                            />
                            <Route
                                path="/view/:uri"
                                element={<RestrictedRoute component={BrowsePage} />}
                            />
                            <Route
                                path="/search"
                                element={<RestrictedRoute component={SearchPage} />}
                            />
                            <Route path="/" element={<Navigate to="/view" replace />} />
                        </Routes>
                        <Footer />
                    </AuthProvider>
                </HashRouter>
            </MuiThemeProviderDynamic>
        </ThemeProvider>
    );
};

const LoginRoute: React.FC = () => {
    const { user } = React.useContext(AuthContext);
    const appConfig = resolveInject(IAppConfigProvider).config;
    const isGuestMode = appConfig.signIn?.options?.includes("guest");
    if (user || isGuestMode) {
        return <Navigate to="/view" replace />;
    }
    return <LoginPage />;
};
const LogoutRoute: React.FC = () => {
    const { user } = React.useContext(AuthContext);
    if (user) {
        localStorage.removeItem("user");
        location.reload();
        return <></>;
    }
    return <Navigate to="/login" replace />;
};
const RestrictedRoute: React.FC<{ component: React.ComponentType<any> }> = ({
    component: Component
}) => {
    const { user } = React.useContext(AuthContext);
    const appConfig = resolveInject(IAppConfigProvider).config;
    const isGuestMode = appConfig.signIn?.options?.includes("guest");
    if (user || isGuestMode) {
        return <Component />;
    }
    return <Navigate to="/login" replace />;
};
